export default "__VITE_ASSET__BaoVgyzv__"